import React, {Component} from 'react'
import Lightbox from 'react-images';
import moment from "moment";
import {Link} from "react-router-dom";
import AdminService from "../../../admin/adminComponents/AdminService";

export default class AplikacjaMobilna extends Component {

    constructor(props) {
        super(props);

        // let data = JSON.parse(localStorage.getItem('aktualnosci'))
        // data = data.filter(el => el.id === parseInt(this.props.id) && el.data.substr(0, 10) === this.props.data);

        this.state = {
            data: [],
            pliki: [],
            brakStrony: false,
            lightBoxOpen: false,
            currentImage: 0,
            loading: true
        };

        this.closeLightbox = this.closeLightbox.bind(this)
    }

    componentWillMount() {
        window.scrollTo(0, 0);
        AdminService.getStronaById(this.props.id)
            .then(function (response) {
                if (response.data === '') {
                    this.setState({
                        brakStrony: true,
                        loading: false
                    });
                } else {
                    this.setState({
                        data: response.data,
                        pliki: response.data.pliki,
                        brakStrony: false,
                        loading: false
                    });
                }

            }.bind(this)).catch(err => {
        })
    }

    closeLightbox() {
        this.setState({lightboxOpen: false})
    }

    render() {
        return (
            <div className="aktualnosci ramka wynik">
                <Link to={'/aktualnosci'}>
                    <div className="backButton" style={{paddingLeft: 10}}><i className="fa fa-arrow-left"> </i> Powrót
                    </div>
                </Link>
                {this.state.loading ? <div>
                    <div className="loaderDim"
                         style={{textAlign: 'center', paddingTop: 50, paddingBottom: 50}}><i
                        className="fa fa-spinner fa-pulse fa-2x fa-fw"
                        style={{
                            color: '#58b13d'
                        }}> </i></div>
                </div> : <div>{this.state.brakStrony ?

                    <div className="row">
                        <div className="col-sm-12 text-center">
                            <h2 style={{marginTop: 150, marginBottom: 150}}>Nie można odnaleźć strony.</h2>
                        </div>
                    </div>

                    :
                    <div className="row">
                        <div className="col-sm-12 text-left" style={{paddingTop: 25}}>
                            <h2 className="text-center" style={{fontWeight: 'bold'}}>{this.state.data.tytul}</h2>
                            <div className="text-center">
                                <b>{moment(this.state.data.dataWpisu).format('LLLL')}</b>,
                                autor: <b>{this.state.data.wpisal}</b></div>
                            <hr/>
                            <div style={{margin: 25}}>
                                {this.state.pliki.length === 0 ? null :
                                    <div>
                                        <Lightbox
                                            images={this.state.pliki.map((item, i) => {
                                                return {
                                                    src: 'data:' + item.typ + ';base64, ' + item.dane,
                                                    caption: 'Marcel BUS'
                                                }
                                            })}
                                            isOpen={this.state.lightboxOpen}
                                            onClickPrev={() => this.setState({currentImage: this.state.currentImage - 1})}
                                            onClickNext={() => this.setState({currentImage: this.state.currentImage + 1})}
                                            onClose={this.closeLightbox}
                                            currentImage={this.state.currentImage}
                                            preventScroll={false}
                                        />
                                        <div className='articleImageWrapper'>
                                            <img
                                                src={'data:' + this.state.pliki[0].typ + ';base64, ' + this.state.pliki[0].dane}
                                                onClick={() => this.setState({lightboxOpen: true, currentImage: 0})}
                                                style={{maxWidth: '100%', maxHeight: 300, cursor: 'pointer'}}/>
                                        </div>
                                    </div>}
                                <div style={{minHeight: 300}}
                                     dangerouslySetInnerHTML={{__html: this.state.data.tresc}}></div>
                            </div>
                            <hr/>
                            {this.state.pliki.length !== 0 ?
                                <div className='row' style={{margin: 25}}>
                                    <div className="col-sm-12"
                                         style={{fontSize: '0.75rem', color: '#696969'}}>Zdjęcia:
                                    </div>
                                    {this.state.pliki.map((item, i) => {
                                            return <div className="col-sm-4">
                                                <img src={'data:' + item.typ + ';base64, ' + item.dane}
                                                     onClick={() => this.setState({
                                                         lightboxOpen: true,
                                                         currentImage: i
                                                     })}
                                                     style={{maxWidth: '100%', cursor: 'pointer'}}/>
                                            </div>
                                    })}
                                </div> : null}
                        </div>
                    </div>}</div>}
            </div>
        )
    }

}



// WEBPACK FOOTER //
// ./src/components/home/homeComponents/aktualnosciComponents/AktualnosciPost.js